import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import { connect } from 'react-redux';
import * as ContractConfirm from './Saga/ContractConfirm';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import { CSVLink, CSVDownload } from "react-csv";
import moment from 'moment';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,

} from '@material-ui/pickers';
import './Css/Form.css';

// import "Components/RentMoney___/node_modules/react-datepicker/dist/react-datepicker.css";
import DateFnsUtils from '@date-io/date-fns';
// import "Components/RentMoney___/node_modules/react-datepicker/dist/react-datepicker.css";
import ja from "date-fns/locale/ja";
// import { Field, reduxForm ,InjectedFormProps} from 'redux-form';
// // import '../../Css/Table.css';

// import DatePicker from "react-datepicker";
// const { MuiPickersUtilsProvider, KeyboardDatePicker } = require('@material-ui/pickers');
interface Props {
  contract_confirm_formData: any,
  contract_confirm_rent_contracts_list: any,
  change_contract_confirm_formData: any,
  search_contract_confirm_rent_contracts_list: any,
  get_contract_confirm_rent_contracts_list: any,
  shops: any,
  // get_rent_contracts: any,
  // change_search_name: any,
  // change_search_contract_date_start: any,
  // change_search_contract_date_end: any,
  // search_contract_date_start: any,
  // search_contract_date_end: any,
  // change_search_tatemono_name: any,
  // handleSubmit:any,
  // onSubmit:any,
  // get_rent_contract_accounting:any,
  // output:any,
  // name:string,
  // date1:string,
  // date2:string
}



interface State {
  reflash: any,
}


const pay_list =[
  {id:0, value:"　"},
  {id:1, value:"振込"},
  {id:2, value:"カード"},
  {id:3, value:"口座振替"}]

const headers = [


  
    { label: "賃貸革命", key: "bk_no_name" },
    { label: "電子契約", key: "cloudsign_completed_at" },
    { label: "申込日", key: "application_date_format" },
    { label: "契約日", key: "contract_date_format" },
    { label: "電子締結日", key: "cloudsign_completed_at2" },
    { label: "店舗", key: "section_name" },
    { label: "担当", key: "user_name" },
    { label: "契約者", key: "contractor_name1" },
    { label: "契約者カナ", key: "contractor_kana1" },
    { label: "区分", key: "division" },
    { label: "物件名", key: "building_name" },
    { label: "号", key: "room_name" },
    { label: "変更内容", key: "change_contents" },
    { label: "契約プラン", key: "rent_m_contract_type_name" },
    { label: "保証会社", key: "rent_m_guarantee_name" },
    { label: "個人／法人", key: "contract_form" },
    { label: "家賃", key: "yachin" },
    { label: "月額保証料", key: "getugaku_hosyo" },
    { label: "敷金", key: "siki" },
    { label: "キャンセル日", key: "cancel_date_format" },


  ];

const defaultSearchFormData = {
  chinkaku_mi: true,
  chinkaku_zumi: false,
  chinkaku_zumi_henkou: true,
  application_date_start: null,
  application_date_end: null,
  contract_date_start: null,
  contract_date_end: null,
  contractor_name1: "",
  building_name: "",
  room_name: "",
  cloudsign_completed_at_start: null,
  cloudsign_completed_at_end: null,
  payment_type: [],
  apply_payment_type: [],
  month_payment_type: [],
  cancel_date_start: null,
  cancel_date_end: null,
  cancel_only: false,
  type: 0,
  is_kanri: true,
  cloudsign_completed_at: false,
  unconfirmed: true,
  tatemono_or_p: 0,
  section_id: 0,
};

class Search extends Component<Props, State> {

  isEmptyValue = (value: any) => {
    if (Array.isArray(value)) {
      return value.length === 0;
    }

    if (typeof value === "string") {
      return value.trim() === "";
    }

    return value === null || value === undefined || value === false || value === 0;
  }

  hasSearchCondition = () => {
    const formData = this.props.contract_confirm_formData;

    return [
      formData.contractor_name1 !== defaultSearchFormData.contractor_name1,
      formData.building_name !== defaultSearchFormData.building_name,
      formData.room_name !== defaultSearchFormData.room_name,
      formData.application_date_start !== defaultSearchFormData.application_date_start,
      formData.application_date_end !== defaultSearchFormData.application_date_end,
      formData.contract_date_start !== defaultSearchFormData.contract_date_start,
      formData.contract_date_end !== defaultSearchFormData.contract_date_end,
      formData.cloudsign_completed_at_start !== defaultSearchFormData.cloudsign_completed_at_start,
      formData.cloudsign_completed_at_end !== defaultSearchFormData.cloudsign_completed_at_end,
      !this.isEmptyValue(formData.payment_type),
      !this.isEmptyValue(formData.apply_payment_type),
      !this.isEmptyValue(formData.month_payment_type),
      formData.cancel_date_start !== defaultSearchFormData.cancel_date_start,
      formData.cancel_date_end !== defaultSearchFormData.cancel_date_end,
      formData.tatemono_or_p !== defaultSearchFormData.tatemono_or_p,
      formData.section_id !== defaultSearchFormData.section_id,
      formData.is_kanri !== defaultSearchFormData.is_kanri,
      formData.cloudsign_completed_at !== defaultSearchFormData.cloudsign_completed_at,
      formData.unconfirmed !== false,
      formData.cancel_only !== defaultSearchFormData.cancel_only,
      formData.chinkaku_mi !== defaultSearchFormData.chinkaku_mi,
      formData.chinkaku_zumi !== defaultSearchFormData.chinkaku_zumi,
      formData.chinkaku_zumi_henkou !== defaultSearchFormData.chinkaku_zumi_henkou,
    ].some(Boolean);
  }

  executeSearch = () => {
    if (!this.hasSearchCondition()) {
      alert("検索条件を入力してください。");
      return;
    }

    this.props.get_contract_confirm_rent_contracts_list();
  }

  constructor(props: Readonly<Props>) {
    super(props);
    this.state = {
      reflash: false,

    };
    // this.props.change_search_name("")
    // this.props.change_search_contract_date_start(new Date())
    // this.props.change_search_contract_date_end(null)
    // this.change_search_name = this.change_search_name.bind(this);

    // this.handleContractionDateChange = this.handleContractionDateChange.bind(this);
    // this.handleContractionDateChangeEnd = this.handleContractionDateChangeEnd.bind(this);

    // this.change_search_tatemono_name = this.change_search_tatemono_name.bind(this);

  }

  componentWillMount() {

    // this.props.initialize({output:true,name:"",date1:"",date2:""});//フォームに初期値を反映させる


  }

  onClear = () => {
    // alert(event.target.name)

    let contract_confirm_formData = this.props.contract_confirm_formData
    contract_confirm_formData = { ...contract_confirm_formData, ...defaultSearchFormData }

    this.props.change_contract_confirm_formData(contract_confirm_formData);
    
    this.props.get_contract_confirm_rent_contracts_list()

    this.setState({ reflash: !this.state.reflash });
}

  handleChange = (event:any) => {
    // alert(event.target.name)
    console.log(event)

    let contract_confirm_formData = this.props.contract_confirm_formData


    if (event.target.name === "chinkaku_mi" || event.target.name === "chinkaku_zumi" || event.target.name === "cancel_only" || event.target.name === "chinkaku_zumi_henkou" || event.target.name === "is_kanri" || event.target.name === "cloudsign_completed_at" || event.target.name === "unconfirmed") {
      contract_confirm_formData[event.target.name] = event.target.checked

    } else {
      contract_confirm_formData[event.target.name] = event.target.value;
    }

    if(event.target.name === "unconfirmed" && !event.target.checked && !contract_confirm_formData.contract_date_start ){
      // contract_confirm_formData.contract_date_start = moment().startOf('month').format("YYYY/MM/DD")
      // contract_confirm_formData.contract_date_end = moment().endOf('month').format("YYYY/MM/DD")
    }


    this.props.change_contract_confirm_formData(contract_confirm_formData);

    if (event.target.name === "cancel_date_start" || event.target.name === "unconfirmed") {
      // this.props.get_contract_confirm_rent_contracts_list()
    }else{
      // this.props.search_contract_confirm_rent_contracts_list()
    }

    this.setState({ reflash: !this.state.reflash });

    this.executeSearch()
    
}

handleDataChange = (event:any) => {
    // alert(event.target.name)
    console.log(event)

    let contract_confirm_formData = this.props.contract_confirm_formData


    if (event.target.name === "chinkaku_mi" || event.target.name === "chinkaku_zumi" || event.target.name === "cancel_only" || event.target.name === "chinkaku_zumi_henkou" || event.target.name === "is_kanri" || event.target.name === "cloudsign_completed_at" || event.target.name === "unconfirmed") {
      contract_confirm_formData[event.target.name] = event.target.checked

    } else {
      contract_confirm_formData[event.target.name] = event.target.value;
    }


    this.props.change_contract_confirm_formData(contract_confirm_formData);

    this.setState({ reflash: !this.state.reflash });

    // this.props.get_contract_confirm_rent_contracts_list()
    
}

handleDateChange = (date:any, name:any) => {
  let contract_confirm_formData = this.props.contract_confirm_formData
  contract_confirm_formData[name] = date
  this.props.change_contract_confirm_formData(contract_confirm_formData);

  if (name === "cancel_date_start" || name === "cancel_date_end" || 
  name === "application_date_start" || name === "application_date_end" || 
  name === "contract_date_start" || name === "contract_date_end" || 
  name === "cloudsign_completed_at_start" || name === "cloudsign_completed_at_end") {
    // this.props.get_contract_confirm_rent_contracts_list()
  }else{
    // this.props.search_contract_confirm_rent_contracts_list()
  }

  this.setState({ reflash: !this.state.reflash });

};

  render() {

    // const { handleSubmit } = this.props;


    return (
      <div className='contract_confirm_search' style={{width:200}}>

        <Card style={{ border: 0, boxShadow: "none", textAlign:"left", overflowY: "scroll", height:window.innerHeight-80 }}>
          <CardContent style={{ padding: 5}}>

            <Button style={{ backgroundColor: "#5cb85c" }} size="small" variant="contained" color="primary">
              <CSVLink style={{textDecoration:"none", color:"white" }} headers={headers} filename={"契約リスト.csv"} data={this.props.contract_confirm_rent_contracts_list.map((row:any) => ({...row, 
              
              cloudsign_completed_at: row.cloudsign_completed_at ? "電子契約" : "",
              cloudsign_completed_at2: row.cloudsign_completed_at ? moment(row.cloudsign_completed_at).format("YYYY/MM/DD") : "",
              division: row.division == 1 ? "サブ" : row.division == 2  ? "管理" : row.division == 3 ? "一般" : row.division == 4 ? "業物" : row.division == 5 ? "業物折半" : row.division == 6 ? "専任":"",
              contract_form: row.contract_form == 1 ? "法人" : "個人",
              
              siki: row.siki > 0 ? row.siki+"ヶ月":"",

            }))}>CSV</CSVLink>
            </Button>
            
          </CardContent>

          <CardContent style={{ padding: 5}}>
            <Button size={"small"} variant="contained" color="primary" onClick={this.executeSearch}>検索</Button>
            <Button size={"small"} variant="contained" color="default" onClick={this.onClear} style={{marginLeft:5}}>条件クリア</Button>
          </CardContent>
          {/* <CardContent style={{ padding: 5, clear:"both"}}>
            <InputLabel id="sectionId-label" style={{marginBottom:0}}>賃貸革命登録</InputLabel>
            <FormControlLabel control={<Checkbox checked={this.props.contract_confirm_formData.chinkaku_mi} name="chinkaku_mi" onChange={this.handleChange} />} label="未" />
            <FormControlLabel control={<Checkbox checked={this.props.contract_confirm_formData.chinkaku_zumi} name="chinkaku_zumi" onChange={this.handleChange} />} label="完了" />
            <FormControlLabel control={<Checkbox style={{paddingTop:0, paddingBottom:0}} checked={this.props.contract_confirm_formData.chinkaku_zumi_henkou} name="chinkaku_zumi_henkou" onChange={this.handleChange} />} label="変更内容あり" />
          </CardContent>

          <RadioGroup row aria-label="position" name="type" onChange={this.handleChange} value={parseInt(this.props.contract_confirm_formData.type)} >
              <FormControlLabel style={{ width: "100%", marginBottom: 0, marginLeft: 0 }} control={<Radio value={0} style={{}} />} label="すべて" />
              <FormControlLabel style={{ width: "100%", marginBottom: 0, marginLeft: 0 }} control={<Radio value={1} style={{}} />} label="物件" />
              <FormControlLabel style={{ width: "100%", marginLeft: 0 }} control={<Radio value={2} style={{}} />} label="P" />
          </RadioGroup> */}

          <CardContent style={{ padding: 5}}>
            <FormControlLabel control={<Checkbox checked={this.props.contract_confirm_formData.unconfirmed} name="unconfirmed" onChange={this.handleChange} />} label="未確認のみ" />
          </CardContent>

          <CardContent style={{ paddingLeft: 5, paddingTop:0, paddingBottom:0 }}>
          <FormControl variant="outlined" fullWidth>
              <InputLabel margin="dense">区分</InputLabel>
              <Select
                margin="dense"
                id="tatemono_or_p"
                name="tatemono_or_p"
                value={this.props.contract_confirm_formData.tatemono_or_p}
                onChange={this.handleChange}
              >
                <MenuItem value={0}>すべて</MenuItem>
                <MenuItem value={1}>建物</MenuItem>
                <MenuItem value={2}>駐車場</MenuItem>
              </Select>
            </FormControl>
          </CardContent>

          <CardContent style={{ paddingLeft: 5, paddingTop:0, paddingBottom:0 }}>
            <TextField fullWidth
              label="契約者名"
              variant="outlined"
              onChange={this.handleDataChange}
              name="contractor_name1"
              value={this.props.contract_confirm_formData.contractor_name1}
              margin="dense"
              // onChange={e => {
              //     this.onChangeDate(e.target.value)
              //   }
              // }
              onKeyDown={e => {
                if (e.key === 'Enter') {
                    // エンターキー押下時の処理
                    this.executeSearch()
                }
              }}
            />
          </CardContent>

          <CardContent style={{ paddingLeft: 5, paddingTop:0, paddingBottom:0 }}>
            <TextField fullWidth
              label="物件名"
              variant="outlined"
              onChange={this.handleDataChange}
              name="building_name"
              value={this.props.contract_confirm_formData.building_name}
              margin="dense"
              onKeyDown={e => {
                if (e.key === 'Enter') {
                    this.executeSearch()
                }
              }}
            />
          </CardContent>

          <CardContent style={{ paddingLeft: 5, paddingTop:0, paddingBottom:0 }}>
            <TextField fullWidth
              label="部屋名"
              variant="outlined"
              onChange={this.handleDataChange}
              name="room_name"
              value={this.props.contract_confirm_formData.room_name}
              margin="dense"
              onKeyDown={e => {
                if (e.key === 'Enter') {
                    this.executeSearch()
                }
              }}
            />
          </CardContent>

          <CardContent style={{ paddingLeft: 5, paddingTop:8, paddingBottom:0 }}>
            <FormControl variant="outlined" fullWidth margin="dense" style={{marginTop:0, marginBottom:0}}>
              <InputLabel id="sectionId-label">店舗</InputLabel>
              <Select
                  labelId="sectionId-label"
                  id="section_id"
                  name="section_id"
                  value={this.props.contract_confirm_formData.section_id}
                  onChange={this.handleChange}
                  // disabled={this.props.formData.id}
                  label="section_id"
                  // size="small"
              >
                  <MenuItem value={0}>全店</MenuItem>
                  
                  {this.props.shops.sort((a:any, b:any) => {return a.dispOrder < b.dispOrder ? -1 : 1;}).filter((a:any) => 
                  a.tenpoNo == 1 || //番町店
                  a.tenpoNo == 2 || //レインボーロード店
                  a.tenpoNo == 3 || //高松駅前店
                  a.tenpoNo == 4 || //高松東店
                  a.tenpoNo == 6 || //高松中央公園店
                  // a.tenpoNo == 10 || //
                  a.tenpoNo == 17 || //本社サンフラワー店
                  a.tenpoNo == 47 //中央通り店
                  ).map(function (item:any, i:any) {
                  return (
                      <MenuItem value={item.tenpoNo}>{item.tenpoName}</MenuItem>
                  );

                  })}

              </Select>
            </FormControl>
          </CardContent>

          <CardContent style={{ padding: 5}}>
            <FormControlLabel style={{ width: "100%", marginBottom: 0 }} control={<Checkbox checked={this.props.contract_confirm_formData.is_kanri} name="is_kanri" onChange={this.handleChange} />} label="管理・サブ" />
            <FormControlLabel style={{ width: "100%", marginBottom: 0 }} control={<Checkbox checked={this.props.contract_confirm_formData.cloudsign_completed_at} name="cloudsign_completed_at" onChange={this.handleChange} />} label="電子契約" />
          </CardContent>

          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja}>
          <CardContent style={{ padding: 5, marginBottom:10 }}>
                  
          <TextField
            fullWidth
            label="申込日 開始"
            type="date"
            name="application_date_start"
            size="small"
            onChange={this.handleDataChange}
            value={moment(this.props.contract_confirm_formData.application_date_start).format("YYYY-MM-DD")}
            InputLabelProps={{
                shrink: true,
            }}
            variant="standard"
          />

          <TextField
            fullWidth
            label="申込日 終了"
            type="date"
            name="application_date_end"
            size="small"
            onChange={this.handleDataChange}
            value={moment(this.props.contract_confirm_formData.application_date_end).format("YYYY-MM-DD")}
            InputLabelProps={{
                shrink: true,
            }}
            variant="standard"
          />


          </CardContent>

          <CardContent style={{ padding: 5, marginBottom:10 }}>
            <TextField
              fullWidth
              label="契約日 開始"
              type="date"
              name="contract_date_start"
              size="small"
              onChange={this.handleDataChange}
              value={moment(this.props.contract_confirm_formData.contract_date_start).format("YYYY-MM-DD")}
              InputLabelProps={{
                  shrink: true,
              }}
              variant="standard"
            />

            <TextField
              fullWidth
              label="契約日 終了"
              type="date"
              name="contract_date_end"
              size="small"
              onChange={this.handleDataChange}
              value={moment(this.props.contract_confirm_formData.contract_date_end).format("YYYY-MM-DD")}
              InputLabelProps={{
                  shrink: true,
              }}
              variant="standard"
            />            
          </CardContent>

          <CardContent style={{ padding: 5, marginBottom:10 }}>
            <TextField
              fullWidth
              label="電契締結日 開始"
              type="date"
              name="cloudsign_completed_at_start"
              size="small"
              onChange={this.handleDataChange}
              value={moment(this.props.contract_confirm_formData.cloudsign_completed_at_start).format("YYYY-MM-DD")}
              InputLabelProps={{
                  shrink: true,
              }}
              variant="standard"
            />
            <TextField
              fullWidth
              label="電契締結日 終了"
              type="date"
              name="cloudsign_completed_at_end"
              size="small"
              onChange={this.handleDataChange}
              value={moment(this.props.contract_confirm_formData.cloudsign_completed_at_end).format("YYYY-MM-DD")}
              InputLabelProps={{
                  shrink: true,
              }}
              variant="standard"
            />
            
          </CardContent>

          {/* <CardContent style={{ padding: 5 }}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel margin="dense">支払区分</InputLabel>
              <Select
                margin="dense"
                id="payment_type"
                name="payment_type"
                value={this.props.contract_confirm_formData.payment_type}
                multiple
                onChange={this.handleChange}
                renderValue={()=>this.props.contract_confirm_formData.payment_type.length > 0 ? this.props.contract_confirm_formData.payment_type.map(function (item:any) {
                  return parseInt(item) > 0 ? pay_list.filter(a => a.id === parseInt(item))[0].value : ""
                }, this).join(',') : ""}

                                // MenuProps={MenuProps}
              >
                <MenuItem value={0}><Checkbox checked={this.props.contract_confirm_formData.payment_type.indexOf(0) > -1} /><ListItemText primary={"　"} /></MenuItem>
                <MenuItem value={1}><Checkbox checked={this.props.contract_confirm_formData.payment_type.indexOf(1) > -1} /><ListItemText primary={"振込"} /></MenuItem>
                <MenuItem value={2}><Checkbox checked={this.props.contract_confirm_formData.payment_type.indexOf(2) > -1} /><ListItemText primary={"カード"} /></MenuItem>
                <MenuItem value={3}><Checkbox checked={this.props.contract_confirm_formData.payment_type.indexOf(3) > -1} /><ListItemText primary={"口座振替"} /></MenuItem>
              </Select>
            </FormControl>
          </CardContent>

          <CardContent style={{ padding: 5 }}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel margin="dense">支払予定区分</InputLabel>
              <Select
                margin="dense"
                id="apply_payment_type"
                name="apply_payment_type"
                value={this.props.contract_confirm_formData.apply_payment_type}
                multiple
                onChange={this.handleChange}
                renderValue={()=>this.props.contract_confirm_formData.apply_payment_type.length > 0 ? this.props.contract_confirm_formData.apply_payment_type.map(function (item:any) {
                  return parseInt(item) > 0 ? pay_list.filter(a => a.id === parseInt(item))[0].value : ""
                }, this).join(',') : ""}

                                // MenuProps={MenuProps}
              >
                <MenuItem value={1}><Checkbox checked={this.props.contract_confirm_formData.apply_payment_type.indexOf(1) > -1} /><ListItemText primary={"振込"} /></MenuItem>
                <MenuItem value={2}><Checkbox checked={this.props.contract_confirm_formData.apply_payment_type.indexOf(2) > -1} /><ListItemText primary={"カード"} /></MenuItem>
                <MenuItem value={3}><Checkbox checked={this.props.contract_confirm_formData.apply_payment_type.indexOf(3) > -1} /><ListItemText primary={"口座振替"} /></MenuItem>
              </Select>
            </FormControl>
          </CardContent>

          <CardContent style={{ padding: 5 }}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel margin="dense">月々支払区分</InputLabel>
              <Select
                margin="dense"
                id="month_payment_type"
                name="month_payment_type"
                value={this.props.contract_confirm_formData.month_payment_type}
                multiple
                onChange={this.handleChange}
                renderValue={()=>this.props.contract_confirm_formData.month_payment_type.length > 0 ? this.props.contract_confirm_formData.month_payment_type.map(function (item:any) {
                  return parseInt(item) > 0 ? pay_list.filter(a => a.id === parseInt(item))[0].value : ""
                }, this).join(',') : ""}

                                // MenuProps={MenuProps}
              >
                <MenuItem value={1}><Checkbox checked={this.props.contract_confirm_formData.month_payment_type.indexOf(1) > -1} /><ListItemText primary={"振込"} /></MenuItem>
                <MenuItem value={2}><Checkbox checked={this.props.contract_confirm_formData.month_payment_type.indexOf(2) > -1} /><ListItemText primary={"カード"} /></MenuItem>
                <MenuItem value={3}><Checkbox checked={this.props.contract_confirm_formData.month_payment_type.indexOf(3) > -1} /><ListItemText primary={"口座振替"} /></MenuItem>
              </Select>
            </FormControl>
          </CardContent> */}

          <CardContent style={{ padding: 5, marginTop:10 }}>
            <TextField
              fullWidth
              label="キャンセル日 開始"
              type="date"
              name="cancel_date_start"
              size="small"
              onChange={this.handleDataChange}
              value={moment(this.props.contract_confirm_formData.cancel_date_start).format("YYYY-MM-DD")}
              InputLabelProps={{
                  shrink: true,
              }}
              variant="standard"
            />
            <TextField
              fullWidth
              label="キャンセル日 終了"
              type="date"
              name="cancel_date_end"
              size="small"
              onChange={this.handleDataChange}
              value={moment(this.props.contract_confirm_formData.cancel_date_end).format("YYYY-MM-DD")}
              InputLabelProps={{
                  shrink: true,
              }}
              variant="standard"
            />
            
          </CardContent>
          {/* <CardContent style={{ padding: 5}}>
            <FormControlLabel control={<Checkbox checked={this.props.contract_confirm_formData.cancel_only} name="cancel_only" onChange={this.handleChange} />} label="キャンセルのみ" />
          </CardContent> */}
          </MuiPickersUtilsProvider>
        </Card>

        <table>

          <tbody>




            {/* <tr >
              <th>お客様名：</th>
              <td >
                <TextField
                  name="name"
                  //   component="input"
                  type="text"
                  //placeholder=""
                  onKeyDown={e => {
                    if (e.keyCode === 13) {
                      // エンターキー押下時の処理
                      this.props.get_rent_contracts()
                    }
                  }}
                  onChange={this.change_search_name}
                  className="form-control"
                />

              </td>
              <th>物件名：</th>
              <td >
                <TextField
                  name="tatemonoName"
                  //   component="input"
                  type="text"
                  //placeholder=""
                  onKeyDown={e => {
                    if (e.keyCode === 13) {
                      // エンターキー押下時の処理
                      this.props.get_rent_contracts()
                    }
                  }}
                  onChange={this.change_search_tatemono_name}
                  className="form-control"
                />

              </td>
              <td>
                <button
                  type="button"
                  style={{ margin: "5px" }}
                  onClick={this.props.get_rent_contracts}
                  className="btn btn-primary float-right"
                >検索</button>
              </td>
            </tr>
            <tr >
              <th>契約日：</th>
              <td colSpan={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja}>


                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="契約日"
                    //   showTodayButton={true}
                    style={{ float: "left" }}
                    autoOk={true}
                    // error={true}
                    // helperText="契約日を選択してください"
                    //   errorMessages={['契約日を選択してください']}
                    name="contractDataStart"
                    //    onChange={this.handleContractionDateChangeStart}
                    value={this.props.search_contract_date_start}
                    //    value={this.props.estimateData.contractDate}
                    onChange={this.handleContractionDateChange}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    //   minDateMessage="契約日を選択してください"
                    // minDate={new Date("2000-01-01")}
                    invalidDateMessage={"日付の形式が違います"}
                  />
           ～
           <KeyboardDatePicker

                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="契約日"
                    style={{ marginLeft: "20px" }}
                    autoOk={true}
                    // error={true}
                    // helperText="申込日を選択してください"
                    //   showTodayButton={true}
                    //  name ="applicationDate"
                    name="contractDataEnd"
                    value={this.props.search_contract_date_end}
                    // //  value={this.props.estimateData.applicationDate}
                    onChange={this.handleContractionDateChangeEnd}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    invalidDateMessage={"日付の形式が違います"}
                  />

                </MuiPickersUtilsProvider>




              </td>

            </tr > */}
          </tbody>
        </table>








      </div>
    );
  }
}




const mapStateToProps = (state: any) => {
  return {
    contract_confirm_formData: state.ContractConfirm.contract_confirm_formData,
    contract_confirm_rent_contracts_list: state.ContractConfirm.contract_confirm_rent_contracts_list,
    shops: state.masterReducer.shops,
  }
}
function mapDispatchToProps(dispatch: any) {
  return {
    change_contract_confirm_formData(state: any) {
      dispatch(ContractConfirm.change_contract_confirm_formData(state))
    },
    search_contract_confirm_rent_contracts_list(state: any) {
      dispatch(ContractConfirm.search_contract_confirm_rent_contracts_list(state))
    },
    get_contract_confirm_rent_contracts_list(state: any) {
      dispatch(ContractConfirm.get_contract_confirm_rent_contracts_list(state))
    },

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Search);
// const form = reduxForm({
//     form: 'formset', // a unique identifier for this form

//     //enableReinitialize: true, // initialValuesプロップが更新されると、フォームも更新されます。
// })(AccountingListSearchComponent)

// export default Form;

